import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { AuthLayout, authInput, authBtn, Link } from "../components/AuthLayout";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); } catch (e2) { setMsg(errMsg(e2)); }
  };
  return (
    <AuthLayout title="Reset your password" subtitle="We'll send a reset link to your email."
      footer={<Link to="/login" className="text-primary font-medium">Back to login</Link>}>
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="forgot-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} />
        {msg && <div className="text-[12px] text-muted-foreground" data-testid="forgot-message">{msg}</div>}
        <button data-testid="forgot-submit-button" className={authBtn}>Send reset link</button>
      </form>
    </AuthLayout>
  );
}

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      toast.success("Password updated. Please log in.");
      nav("/login");
    } catch (e2) { setErr(errMsg(e2)); }
  };
  return (
    <AuthLayout title="Choose a new password" subtitle="Use at least 6 characters." footer={<Link to="/login" className="text-primary font-medium">Back to login</Link>}>
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="reset-password-input" type="password" minLength={6} required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className={authInput} />
        {err && <div className="text-down text-[12px]">{err}</div>}
        <button data-testid="reset-submit-button" className={authBtn}>Update password</button>
      </form>
    </AuthLayout>
  );
}
